import React from 'react';
import { useHistory } from 'react-router-dom'; 
import { Box, Button, Typography } from '@mui/material';

function Page2SubPageB1() {
  const history = useHistory(); 

  return (
    <Box p={4}>
      <Box display="flex" justifyContent="center" gap={2} mt={2}>
        <Button variant="contained" onClick={() => history.push('/page2/b/b1/a')}>
          Federal
        </Button>
        <Button variant="contained" onClick={() => history.push('/page2/b/b1/b')}>
          State
        </Button>
        <Button variant="contained" onClick={() => history.push('/page2/b/b1/c')}>
          Local
        </Button>
      </Box>
    </Box>
  );
}

export default Page2SubPageB1;
/*
import React from 'react';
import { Box, Typography } from '@mui/material';

function Page1SubPageB1() {
  return (
    <Box p={4}>
      <Typography variant="h4">Enacted Laws</Typography>
    </Box>
  );
}

export default Page1SubPageB1;
*/